<template>
  <v-container fluid>

  <div class="headline text-xs-left">
    Payment Help
  </div>

  <LearnItem>
    <template slot="title">What are the payment options?</template>
    You can choose to accept payments only in person, only by credit card, or both!
    Choose the option you want on your <router-link :to="{name: 'SiteSettings'}">Site Settings</router-link> page.
   </LearnItem>
   <LearnItem>
     <template slot="title">How do I setup credit cards?</template>
     SmartKidsMarket integrates with <a href="https://stripe.com" target=_system >Stripe payments</a>. Stripe is one of the top online
     payment processors used by KickStarter, Lyft, Pinterest and others.<br /><br />

     To use credit cards you'll create a free Stripe account
     and then Buyers can pay you
     using credit cards. For safety, SmartKidsMarket never processes or stores any credit card
     information it goes straight to Stripe.

     <br /><br />
     Go to your <router-link :to="{name: 'SiteSettings'}">Site Settings</router-link>
     and click the "I want to allow credit cards" link.
     From there you can click the "Connect to Stripe" button which will take you
     Stripe.com and walk you through creating a free account to accept credit cards.


  </LearnItem>

  <LearnItem>
    <template slot="title">What are the credit card fees?</template>
    Stripe.com adds a fee of 2.9% + 30¢ for each credit card payment that goes directly to Stripe.
    Kids, you should add in the credit card fee as part of your cost of goods.
  </LearnItem>

   <LearnItem>
     <template slot="title">How can I refund a credit card payment?</template>
     From your <router-link :to="{name: 'Orders'}">orders</router-link> page you
     can select "Refund" for any open oder and the full cost of the order will be
     refunded to the buyer's credit card.
  </LearnItem>

  <LearnItem>
    <template slot="title">How does sales tax work?</template>
    You can choose to add sales tax to your orders from the <router-link :to="{name: 'SiteSettings'}">Site Settings</router-link>
    page. The system will use the delivery address location to compute the sales tax rate.
    Sales tax can get much more complex and you should consult a qualified tax
    professional to ensure your compliance with all applicable salees tax reporting laws.
 </LearnItem>

 <LearnItem>
   <template slot="title">Do I need to collect sales tax?</template>
   We believe many of our sellers will be considered "occasional sellers" by the IRS,
   however we cannot provide tax advice. If you're concerned you should consult a qualified tax
   professional to ensure your compliance with all applicable salees tax reporting laws.
</LearnItem>

  </v-container>

</template>

<script>

import LearnItem from './LearnItem.vue'

export default {
  components: {
    LearnItem
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

</style>
